import React from "react";
import { Modal } from "react-bootstrap";
import { LoadingSection } from "./LoadingSection";

interface LoadingScreenProps {
  isLoading?: boolean;
}

function LoadingScreen({ isLoading = true }: LoadingScreenProps) {
  if (!isLoading) {
    return <></>;
  }
  return (
    <Modal show={isLoading} aria-labelledby="loading-modal" centered>
      <Modal.Body>
        <LoadingSection />
      </Modal.Body>
    </Modal>
  );
}

export default LoadingScreen;
